$(document).ready(function () {
  "use strict";

  var myModal = new bootstrap.Modal(document.getElementById("staticBackdrop"));

  window.Parsley.addValidator("unique", {
    requirementType: "string",
    validateString: function (value, requirement) {
      let valid = true;
      let counter = 0;

      $("[data-parsley-unique]").each(function (index, element) {
        if (element.value == value) {
          counter++;
        }
      });

      if (counter >= 2) {
        valid = false;
      }

      return valid;
    },
    messages: {
      en: "This value must be unique between family members",
    },
  });
  
    window.Parsley.addAsyncValidator('hofFamilyCNICValidator', function (xhr) {
      // Access the jQuery object for the element being validated
      console.log(this.$element);

      // Parse the server response JSON
      var response = JSON.parse(xhr.responseText);

      // Check if the validation failed
      if (xhr.status !== 200) {
          // Set the custom error message for the element
          this.options.remoteMessage = response.message || "This CNIC already exists.";

          // Return false to indicate validation failure
          return false;
      }

      // Return true to indicate validation success
      return true;
  },CNIC_VALIDATOR_ROUTE);

  window.Parsley.addValidator("image", {
    requirementType: ["string", "integer"],
    validateString: function (value, id, KiB) {
      let file = $(`#${id}`)[0].files[0];

      let fileCheck = file.type == "image/jpeg" || file.type == "image/png";

      let sizeCheck = file.size / 1024 <= KiB;

      return fileCheck && sizeCheck;
    },
    messages: {
      en: "This file must be under 500KBs and must be either PNG,JPEG or JPG.",
    },
  });

  let parsley = $("#censusForm").parsley({
    classHandler: function (Field) {
      let check = Field.$element.hasClass("select2-hidden-accessible");
      if (check) {
        return Field.$element
          .parent()
          .find(".select2-selection.select2-selection--single")
          .first();
      }
    },
    errorsContainer: function (Field) {
      let check = Field.$element.hasClass("select2-hidden-accessible");
      if (check) {
        return Field.$element.parent();
      }
    },
  });

  $("#censusFormSubmission").click(function (e) {
    parsley.validate();

    $("#dataVerification").prop("checked", false);

    $("#modalTBody").html("");

    if (parsley.isValid() !== false) {
      myModal.show();

      let hofFamilyName = $("#hofFamilyName").val();
      let fatherName = $("#hofFamilyFatherName").val();
      let hofFamilyGender = $("#hofFamilyGender option:selected").text();
      let dob = $("#hofFamilyDateOfBirth")
        .parent()
        .find(".flatpickr-input")
        .val();
      let hofFamilyCNIC = $("#hofFamilyCNIC").val();
      let membershipNo = $("#hofFamilyMembershipName").val();
      let hofFamilyMaritalStatus = $(
        "#hofFamilyMaritalStatus option:selected"
      ).text();
      let hofFamilyAcademicQualification = $(
        "#hofFamilyAcademicQualification"
      ).val();
      let hofFamilyProfessionalQualification = $(
        "#hofFamilyProfessionalQualification"
      ).val();
      let hofFamilyOccupationalStatus = $(
        "#hofFamilyOccupationalStatus option:selected"
      ).text();
      let hofFamilyMonthlyIncome = $(
        "#hofFamilyMonthlyIncome option:selected"
      ).text();
      let hofFamilyDisability = $(
        "#hofFamilyDisability option:selected"
      ).text();

      setHtml("#modalName", hofFamilyName);
      setHtml(
        "#modalResidentialAddress",
        $("#hofFamilyResidentialAddress").val()
      );
      setHtml("#modalMobileNo", $("#hofFamilyMobileNumber").val());
      setHtml(
        "#modalResidentialStatus",
        $("#hofFamilyResidentialStatus  option:selected").text()
      );
      setHtml("#modalFatherName", fatherName);
      setHtml("#modalGrandFatherName", $("#hofFamilyGrandFatherName").val());
      setHtml("#modalArea", $("#hofFamilyArea  option:selected").text());
      setHtml("#modalEmail", $("#hofFamilyEmail").val());
      setHtml(
        "#modalResidentialType",
        $("#hofFamilyResidentialType option:selected").text()
      );
      setHtml("#modalSurname", $("#hofFamilySurname option:selected").text());
      setHtml("#modalCity", $("#hofFamilyCity option:selected").text());
      setHtml(
        "#modalResidentialInformation",
        $("#hofFamilyResidentialInformation option:selected").text()
      );

      addRow(
        hofFamilyName + " " + fatherName,
        hofFamilyGender,
        dob,
        "SELF",
        hofFamilyCNIC,
        membershipNo,
        hofFamilyMaritalStatus,
        hofFamilyAcademicQualification,
        hofFamilyProfessionalQualification,
        hofFamilyOccupationalStatus,
        hofFamilyMonthlyIncome,
        hofFamilyDisability
      );

      let relationWithHead = $(".getFamilyMember-relationWithHead");
      let name = $(".getFamilyMember-name");
      let gender = $(".getFamilyMember-gender");
      let dateOfBirth = $(".getFamilyMember-dateOfBirth.flatpickr-input");
      let cnic = $(".getFamilyMember-cnic");
      let membershipNumber = $(".getFamilyMember-membershipNumber");
      let maritalStatus = $(".getFamilyMember-maritalStatus");
      let disability = $(".getFamilyMember-disability");
      let academicQualification = $(".getFamilyMember-academicQualification");
      let professionalQualification = $(
        ".getFamilyMember-professionalQualification"
      );
      let occupationalStatus = $(".getFamilyMember-occupationalStatus");
      let monthlyIncome = $(".getFamilyMember-monthlyIncome");

      if (relationWithHead.length > 0) {
        for (var i = 0; i < relationWithHead.length; i++) {
          addRow(
            $(name[i]).val(),
            $(gender[i]).find("option").filter(":selected").text(),
            $(dateOfBirth[i]).val(),
            $(relationWithHead[i]).find("option").filter(":selected").text(),
            $(cnic[i]).val(),
            $(membershipNumber[i]).val(),
            $(maritalStatus[i]).find("option").filter(":selected").text(),
            $(academicQualification[i]).val(),
            $(professionalQualification[i]).val(),
            $(occupationalStatus[i]).find("option").filter(":selected").text(),
            $(monthlyIncome[i]).find("option").filter(":selected").text(),
            $(disability[i]).find("option").filter(":selected").text()
          );
        }
      }
    }
  });

  $("#dataVerification").change(function () {
    if ($(this).is(":checked")) {
      $("#modalFinalSubmit").prop("disabled", false);
    } else {
      $("#modalFinalSubmit").prop("disabled", true);
    }
  });

  CNICNumber();

  $("#hofFamilySurname").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: SURNAME_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's surname",
  });

  $("#hofFamilyCountry").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: COUNTRY_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's country",
  });

  $("#hofFamilyCountry").change(function () {
    const countryID = $(this).val();

    $("#hofFamilyState").val("").change();

    $("#hofFamilyState").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: STATE_SELECT2_ROUTE + "?country_id=" + countryID,
        dataType: "json",
      },
      placeholder: "Select the head of family's state",
    });
  });

  $("#hofFamilyState").change(function () {
    const stateID = $(this).val();

    $("#hofFamilyCity").val("").change();

    $("#hofFamilyCity").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: CITY_SELECT2_ROUTE + "?state_id=" + stateID,
        dataType: "json",
      },
      placeholder: "Select the head of family's city",
    });
  });

  $("#hofFamilyCity").change(function () {
    const cityID = $(this).val();

    $("#hofFamilyArea").val("").change();

    $("#hofFamilyArea").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: AREA_SELECT2_ROUTE + "?city_id=" + cityID,
        dataType: "json",
      },
      placeholder: "Select the head of family's area",
    });
  });

  // edit handler
  // if ($("#hofFamilyCountry").val() && $('#hofFamilyState').val()) {
  let state = $("#hofFamilyState").val();
  let city = $("#hofFamilyCity").val();
  let area = $("#hofFamilyArea").val();

  $("#hofFamilyCountry").trigger("change");

  $("#hofFamilyState").val(state).trigger("change");

  $("#hofFamilyCity").val(city).trigger("change");

  $("#hofFamilyArea").val(area).trigger("change");
  // }

  $("#hofFamilyResidentialStatus").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: RESIDENTIAL_STATUS_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's residential status",
  });

  $("#hofFamilyResidentialType").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: RESIDENTIAL_TYPE_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's residential type",
  });

  $("#hofFamilyResidentialInformation").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: RESIDENTIAL_INFORMATION_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's residential information",
  });

  familyGender();

  familyMaritalStatus();

  selectDisability();

  $("#hofFamilyCommunity").select2({
    ajax: {
      delay: 250, // wait 250 milliseconds before triggering the request
      url: COMMUNITY_SELECT2_ROUTE,
      dataType: "json",
    },
    placeholder: "Select the head of family's community",
  });

  occupationalStatus();

  monthlyIncome();

  CNICExpiry();

  dateOfBirth();

  $("form").on("change", ".cnic-expiry", function () {
    let base = $(this).parent().parent().parent();

    if ($(this).is(":checked")) {
      base.find("input[type='hidden']").attr("disabled", true);
      base.find("input[type='hidden']").attr("required", false);
      base.find("input[type='text']").attr("disabled", true);
      base.find("input[type='text']").attr("required", false);
      base.find("input[type='text']").hide();
    } else {
      base.find("input[type='hidden']").attr("disabled", false);
      base.find("input[type='hidden']").attr("required", true);
      base.find("input[type='text']").attr("disabled", false);
      base.find("input[type='text']").attr("required", true);
      base.find("input[type='text']").show();
    }
  });

  $("form").on("click", ".removeFamilyMember", function () {
    $(this).parent().parent().parent().parent().parent().remove();

    doNumberWork();
  });

  let index = 0;

  // Add more
  $("#addFamilyMember").click(function () {
    index++;

    appendFamily(index);

    afterAdd();
  });

  function appendFamily(index, child = null) {
    let cnicValidator = CNIC_VALIDATOR_ROUTE;
    let membershipValidator = MEMBERSHIP_VALIDATOR_ROUTE;

    if (child) {
      cnicValidator = CNIC_VALIDATOR_ROUTE.replace(":id", child.id);
      membershipValidator = MEMBERSHIP_VALIDATOR_ROUTE.replace(":id", child.id);
    }

    let relationWithHead = "<option></option>";

    if (child?.relation_with_head) {
      let head = child?.relation_with_head;
      relationWithHead = `<option value="${head.id}">${head.name}</option>`;
    }

    let gender = "<option></option>";

    if (child?.gender) {
      let item = child?.gender;
      gender = `<option value="${item.id}">${item.name}</option>`;
    }

    let checked = null;

    checked = child?.cnic_expiry_lifetime ? "checked" : null;

    let maritalStatus = "<option></option>";

    if (child?.marital_status) {
      let item = child?.marital_status;
      maritalStatus = `<option value="${item.id}">${item.name}</option>`;
    }

    let disability = "<option></option>";

    if (child?.disability) {
      let item = child?.disability;
      disability = `<option value="${item.id}">${item.name}</option>`;
    }

    let occupationalStatus = "<option></option>";

    if (child?.occupational_status) {
      let item = child?.occupational_status;
      occupationalStatus = `<option value="${item.id}">${item.name}</option>`;
    }

    let monthlyIncome = "<option></option>";

    if (child?.monthly_income) {
      let item = child?.monthly_income;
      monthlyIncome = `<option value="${item.id}">${item.name}</option>`;
    }

    let html = `
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-8">
                <h1 class="display-6 mb-2">Family Member <span class="familyNumbers"></span></h1>
              </div>

              <div class="col-4 text-end mb-2">
                <button type="button" class="btn btn-dark waves-effect waves-light removeFamilyMember"><i
                    class="fe-minus me-1"></i> Remove Family Member</button>
              </div>

              <div class="col-12">
                <p class="sub-header">Fields marked with <span class="text-danger">*</span> are required</p>
              </div>

              <div class="col-12 mb-3">
                <h4>Basic Information</h4>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Relation With Head of Family
                  <span class="text-danger">*</span>
                </label>
                <select name="familyMember[${index}][relationWithHead]" class="form-control familyRelationWithHead getFamilyMember-relationWithHead" required>
                  ${relationWithHead}
                </select>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label  class="form-label">
                  Full Name
                  <span class="text-danger">*</span>
                </label>
                <input type="text" name="familyMember[${index}][name]"  class="form-control getFamilyMember-name"
                  placeholder="Enter the head of family's name" required value="${child?.name ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Gender
                  <span class="text-danger">*</span>
                </label>
                <select name="familyMember[${index}][gender]" class="form-control familyGender getFamilyMember-gender" required>
                  ${gender}
                </select>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Date of birth
                  <span class="text-danger">*</span>
                </label>
                <input type="text" name="familyMember[${index}][dateOfBirth]" class="form-control dateOfBirth getFamilyMember-dateOfBirth"
                  required placeholder="Enter the head of family's date of birth" value="${child?.date_of_birth ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  CNIC Number
                  <span class="text-danger">*</span>
                </label>
                <input type="text" name="familyMember[${index}][cnic]" class="form-control CNICNumber getFamilyMember-cnic"
                placeholder="_____-_______-_" required pattern="^[0-9]{5}-[0-9]{7}-[0-9]{1}$"
                data-parsley-trigger="change"
                data-parsley-remote="${cnicValidator}"
                data-parsley-remote-message="This CNIC already exists."
                data-parsley-pattern-message="This value must be a valid CNIC number"
                data-parsley-unique value="${child?.cnic ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <div class="row">
                  <div class="col-8">
                    <label class="form-label">
                      CNIC Expiry
                      <span class="text-danger">*</span>
                    </label>
                    <input type="text" name="familyMember[${index}][cnic_expiry]"  class="form-control CNICExpiry getFamilyMember-cnic_expiry"
                      required placeholder="Enter the head of family's CNIC expiry" value="${child?.cnic_expiry ?? ''}">
                  </div>
                  <div class="col-4 mt-4">
                    <div class="form-check mb-2 form-check-primary">
                      <input type="checkbox" name="familyMember[${index}][cnic_expiry]"
                        class="cnic-expiry form-check-input getFamilyMember-cnic_expiry_check" value="lifetime" id="CNICExpiryLifetime${index}" ${checked}>
                      <label class="form-check-label" for="CNICExpiryLifetime${index}">Lifetime</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Membership Number
                </label>
                <input type="text" name="familyMember[${index}][membershipNumber]" class="form-control getFamilyMember-membershipNumber"
                data-parsley-remote="${membershipValidator}"
                      data-parsley-remote-message="Membership number already exists."
                placeholder="Enter the membership number" data-parsley-unique value="${child?.membership_number ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label  class="form-label">
                  Marital Status
                  <span class="text-danger">*</span>
                </label>
                <select name="familyMember[${index}][maritalStatus]"  class="form-control familyMaritalStatus getFamilyMember-maritalStatus" required>
                  ${maritalStatus}
                </select>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label  class="form-label">
                  Disability
                </label>
                <select name="familyMember[${index}][disability]" class="form-control selectDisability getFamilyMember-disability">
                  ${disability}
                </select>
              </div>

              <div class="col-12 mb-3">
                <h4>Professional Details</h4>
              </div>


              <div class="col-md-6 col-lg-4 mb-3">
                <label  class="form-label">
                  Academic Qualification
                </label>
                <input type="text" name="familyMember[${index}][academicQualification]"
                  class="form-control getFamilyMember-academicQualification" placeholder="Enter the head of family's academic qualification" value="${child?.academic_qualification ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Professional Qualification
                </label>
                <input type="text" name="familyMember[${index}][professionalQualification]"
                   class="form-control getFamilyMember-professionalQualification"
                  placeholder="Enter the head of family's professional qualification" value="${child?.professional_qualification ?? ''}">
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Occupational Status
                  <span class="text-danger">*</span>
                </label>
                <select name="familyMember[${index}][occupationalStatus]" class="form-control occupationalStatus getFamilyMember-occupationalStatus"
                  required>
                  ${occupationalStatus}
                </select>
              </div>

              <div class="col-md-6 col-lg-4 mb-3">
                <label class="form-label">
                  Monthly Income
                </label>
                <select name="familyMember[${index}][monthlyIncome]" class="form-control monthlyIncome getFamilyMember-monthlyIncome">
                  ${monthlyIncome}
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
    `;

    $("#AppendFamily").append(html);
  }

  if (CHILDREN.length) {
    CHILDREN.forEach((element) => {
      index++;
      console.log(element);
      appendFamily(index, element);
      afterAdd();
      $(".cnic-expiry").trigger("change");
    });
  }

  function afterAdd() {
    doNumberWork();

    familyRelationWithHead();
    familyGender();
    dateOfBirth();
    CNICExpiry();
    CNICNumber();
    familyMaritalStatus();
    selectDisability();
    occupationalStatus();
    monthlyIncome();
  }

  function doNumberWork() {
    let familyMember = 0;
    $(".familyNumbers").each(function () {
      $(this).html(`#${++familyMember}`);
    });
  }

  function familyGender() {
    $(".familyGender").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: GENDER_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's gender",
    });
  }

  function familyRelationWithHead() {
    $(".familyRelationWithHead").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: RELATION_WITH_HOF_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's relation with head",
    });
  }

  function dateOfBirth() {
    $(".dateOfBirth").flatpickr({
      altInput: true,
      altFormat: "d F Y",
    });
  }

  function CNICExpiry() {
    $(".CNICExpiry").flatpickr({
      altInput: true,
      altFormat: "d F Y",
    });
  }

  function CNICNumber() {
    $(".CNICNumber").inputmask("99999-9999999-9");
  }

  function familyMaritalStatus() {
    $(".familyMaritalStatus").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: MARITAL_STATUS_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's marital status",
    });
  }

  function selectDisability() {
    $(".selectDisability").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: DISABILITY_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's disability",
    });
  }

  function occupationalStatus() {
    $(".occupationalStatus").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: OCCUPATIONAL_STATUS_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's occupational status",
    });
  }

  function monthlyIncome() {
    $(".monthlyIncome").select2({
      ajax: {
        delay: 250, // wait 250 milliseconds before triggering the request
        url: MONTHLY_INCOME_SELECT2_ROUTE,
        dataType: "json",
      },
      placeholder: "Select the head of family's monthly income",
    });
  }

  function setHtml(key, html) {
    $(key).html(html);
  }

  function addRow(
    fullNameWithFather,
    gender,
    dob,
    relationshipWithHOF,
    cnic,
    membershipNo,
    maritalStatus,
    academicQualification,
    professionalQualification,
    occupationalStatus,
    monthlyIncome,
    disability
  ) {
    let html = `
      <tr>
        <td>${fullNameWithFather}</td>
        <td>${gender}</td>
        <td>${dob}</td>
        <td>${relationshipWithHOF}</td>
        <td>${cnic}</td>
        <td>${membershipNo}</td>
        <td>${maritalStatus}</td>
        <td>${academicQualification}</td>
        <td>${professionalQualification}</td>
        <td>${occupationalStatus}</td>
        <td>${monthlyIncome}</td>
        <td>${disability}</td>
      </tr>
    `;

    $("#modalTBody").append(html);
  }
});
